<template>
  <el-dialog
      id="createTestCollectionOrderDialog"
      :title="$t('text.syncOrderStatusConfig')"
      :visible="isShowSyncPayoutInitOrderConfigDialog"
      width="600px"
      @open="openDialog"
      @close="closeDialog"
      :close-on-click-modal="false"
  >
    <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="170px"
        v-show="submitted === false"
    >
<!--      <el-form-item-->
<!--          :label="$t('text.startTime')"-->
<!--          prop="startTime"-->
<!--      >-->
<!--        <el-input-->
<!--            v-model="form.startTime"-->
<!--            auto-complete="off"-->
<!--            :placeholder="$t('message.inputTimeToMinute')"-->
<!--        />-->
<!--      </el-form-item>-->

<!--      <el-form-item-->
<!--          :label="$t('text.endTime')"-->
<!--          prop="endTime"-->
<!--      >-->
<!--        <el-input-->
<!--            v-model="form.endTime"-->
<!--            auto-complete="off"-->
<!--            :placeholder="$t('message.inputTimeToMinute')"-->
<!--        />-->
<!--      </el-form-item>-->

      <el-form-item
          :label="$t('text.submittedTime')"
          prop="submitDateTimeRange"
          :inline-message="true"
      >
        <el-date-picker
            v-model="submitDateTimeRange"
            type="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :range-separator="$t('text.to')"
            :start-placeholder="$t('text.startTime')"
            :end-placeholder="$t('text.endTime')"
            @change="createTimeChange"
        />
      </el-form-item>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog" v-if="submitted === false">{{ $t('text.cancel') }}</el-button>
      <el-button type="primary" @click="submit" v-if="submitted === false">{{
          $t('text.confirm')
        }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import moment from "moment/moment";

export default {
  props: {
    isShowSyncPayoutInitOrderConfigDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        // startTime:"10",
        // endTime:"60",
        startDateTime: "",
        endDateTime: "",
      },
      submitDateTimeRange: null,
      rules: {
        merchantUserId: [
          {required: true, message: this.$t('message.inputMerchantUserId')},
        ],
        anotherField: [
          {
            validator: this.validateMerchantFields,
            trigger: 'blur'
          }
        ]
      },
      loading: null,
      title: "",
      submitted: false,
      result: {
        success: false,
        message: "",
        link: ""
      }
    };
  },
  methods: {
    createTimeChange(e) {
      if (e) {
        this.form.startDateTime = e[0];
        this.form.endDateTime = e[1];
      } else {
        this.form.startDateTime = "";
        this.form.endDateTime = "";
      }
    },
    lockDialog() {
      this.loading = this.$loading({
        lock: true,
        text: this.$t("text.loading"),
        spinner: "el-icon-loading",
        target: "#createTestCollectionOrderDialog .el-dialog"
      });
    },
    unlockDialog() {
      if (this.loading !== null) {
        this.loading.close();
      }
    },
    openDialog() {
      this.title = this.$t('text.testOrder');
      this.submitted = false;
      this.result = {
        success: false,
        message: "",
        link: ""
      };
      let start = moment().subtract(1, 'hours').format("YYYY-MM-DD HH:mm:ss");
      let end = moment().subtract(10, 'minutes').format("YYYY-MM-DD HH:mm:ss");
      this.form.startDateTime = start;
      this.form.endDateTime = end;
      this.submitDateTimeRange = [start, end];
    },
    closeDialog() {
      this.form.merchantUserId = '';
      this.form.orderId = '';
      this.form.merchantOrderId = '';
      this.$refs.form.resetFields();
      this.$emit("update:isShowSyncPayoutInitOrderConfigDialog", false);
    },
    submit() {
      this.$refs.form.validate((valid) => {
            if (valid) {
              this.lockDialog();
              this.$axios
                  .post("/order/syncPayoutInitOrderJob", this.form)
                  .then((res) => {
                    this.unlockDialog();
                    if (res.code === 200) {
                      this.$bus.$emit("refresh");
                      this.closeDialog();
                      this.$notify({
                        title: `${this.$t('text.success')}`,
                        message: res.msg,
                        type: "success",
                      });
                      return true;
                    } else {
                      this.$notify.error({
                        title: this.$t("text.prompt"),
                        message: res.msg
                      });
                      return false;
                    }
                  })
                  .catch(() => {
                    this.unlockDialog();
                    this.$notify.error({
                      title: this.$t("text.prompt"),
                      message: this.$t("message.sysError")
                    });
                  });
            } else {
              return false;
            }
          }
      );
    },
    mounted() {
      this.openDialog();
    }
  }
};
</script>